import { Component, forwardRef, ViewChild, AfterViewInit, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validators } from '@angular/forms';
import { AbstractInput } from '@spaq/shared/components/forms/abstract-input';

import { getConfigByScope } from '@spaq/utils/functions';

@Component({
	selector: 'plancton-input-email',
	template: `
		<kendo-formfield>
			<kendo-label [for]="formControlName" [text]="label"></kendo-label>
			<input
				[id]="formControlName"
				[name]="formControlName"
				[disabled]="disabled"
				[autofocus]="true"
				[autocomplete]="true"
				autocomplete="email"
				type="email"
				kendoTextBox
				[(ngModel)]="value"
				(ngModelChange)="updateModel()"
				(blur)="onModelTouched()"
			/>

			<small class="alert-danger" *ngIf="!isValid">
				{{ control.hasError('required') ? 'Votre adresse courriel est requise' : '' }}
				{{ control.hasError('email') ? ('SHARED.FORMS.INPUT_EMAIL.IS_INVALID' | translate) : '' }}
				{{
					control.hasError('allowedDomain')
						? "Cette adresse courriel n'est pas permise. Merci d'utiliser une addresse se terminant par " + allowedDomains
						: ''
				}}
				{{
					control.hasError('deniedDomain')
						? "Votre adresse de courriel professionnel n'est pas autorisée. Utilisez une adresse de courriel personnel."
						: ''
				}}
			</small>
		</kendo-formfield>
	`,
	styles: [],
	providers: [
		{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => InputEmailComponent), multi: true },
		{ provide: NG_VALIDATORS, useExisting: forwardRef(() => InputEmailComponent), multi: true }
	]
})
export class InputEmailComponent extends AbstractInput {
	@Input()
	label = 'Adresse courriel';
	@Input() checkDomain = false;
	validateFn = (control: AbstractControl) => {
		if (control.value.length) {
			const emailValid = Validators.email(control);

			if (emailValid === null) {
				const domain = control.value.split('@')[1];

				const allowedEmail = getConfigByScope('allowRegistrationDomains');

				if (allowedEmail && allowedEmail.length) {
					if (allowedEmail.includes(domain)) {
						return null;
					}
					return { allowedDomain: true };
				}

				const deniedEmail = getConfigByScope('denyRegistrationDomains');

				if (this.checkDomain && deniedEmail && deniedEmail.length) {
					if (deniedEmail.includes(domain)) {
						return { deniedDomain: true };
					}
					return null;
				}
			} else {
				return emailValid;
			}
		}

		return null;
	};
	get allowedDomains() {
		return (
			'@' +
			getConfigByScope('allowRegistrationDomains')
				.filter(x => x !== 'spaq.com')
				.join(', @')
		);
	}

	validate(control: AbstractControl): ValidationErrors | null {
		return this.validateFn(control);
	}
}
